import React from 'react';

import { TextLink } from '@src/components/atoms/text-link';
import { TitleUnderline } from '@src/components/atoms/title-underline';
import { useAuth } from '@src/hooks/use-auth';
import { variables } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { StyledFooterMenu } from './styles';

const b = bemClassName('footer-menu');

const FooterMenu = () => {
  const { isAuthenticated } = useAuth();

  return (
    <StyledFooterMenu>
      <div className={b()}>
        <TitleUnderline text="Quick Links" />

        <ul className={b('list')}>
          <li className={b('list', 'item')}>
            <TextLink color={variables.colors.white} to="/">
              Home
            </TextLink>
          </li>
          {isAuthenticated && (
            <>
              <li className={b('list', 'item')}>
                <TextLink color={variables.colors.white} to="/user/dashboard">
                  Dashboard
                </TextLink>
              </li>

              <li className={b('list', 'item')}>
                <TextLink color={variables.colors.white} to="/user/recipes">
                  Recipes
                </TextLink>
              </li>

              <li className={b('list', 'item')}>
                <TextLink color={variables.colors.white} to="/user/tracking">
                  Tracking
                </TextLink>
              </li>
            </>
          )}
          {!isAuthenticated && (
            <>
              <li className={b('list', 'item')}>
                <TextLink color={variables.colors.white} to="/pricing">
                  Pricing
                </TextLink>
              </li>

              <li className={b('list', 'item')}>
                <TextLink color={variables.colors.white} to="/about">
                  About
                </TextLink>
              </li>
            </>
          )}
          <li className={b('list', 'item')}>
            <TextLink color={variables.colors.white} to="/blog">
              Blog
            </TextLink>
          </li>
        </ul>

        <div className={b('legal-title')}>
          <TitleUnderline text="Legal" />
        </div>

        <ul className={b('list')}>
          <li className={b('list', 'item')}>
            <TextLink color={variables.colors.white} to="/terms-of-service">
              Terms of Service
            </TextLink>
          </li>
          <li className={b('list', 'item')}>
            <TextLink color={variables.colors.white} to="/privacy-policy">
              Privacy Policy
            </TextLink>
          </li>
          <li className={b('list', 'item')}>
            <TextLink color={variables.colors.white} to="/user-data-deletion">
              Data Deletion Policy
            </TextLink>
          </li>
        </ul>
      </div>
    </StyledFooterMenu>
  );
};

export default FooterMenu;
